import { BlogSection } from '@/types/blog';

export const introSection: BlogSection = {
  id: 'neue-aera-webentwicklung',
  title: 'Eine neue Ära der Webentwicklung',
  content: `
    <h3>Mein technischer Hintergrund</h3>
    
    <p>
      Als Finanzcoach liegt meine Kernkompetenz zwar nicht in der professionellen Webentwicklung, jedoch bringe ich als 
      "Technik-Enthusiast" durchaus einige Erfahrungen mit. Meine Begeisterung für das Programmieren reicht weit zurück – 
      bereits als 14-Jähriger habe ich auf dem C64 BASIC programmiert. Später, Anfang der 1990er-Jahre während meines 
      Biologie-Studiums, hatte ich Programmierkurse in C++ besucht und mir anschließend HTML selbst beigebracht.
    </p>
    
    <div class="my-8">
      <div class="rounded-xl overflow-hidden shadow-soft">
        <img 
          src="/lovable-uploads/174d7363-542e-4ae0-93cc-6bd9a69114ad.png" 
          alt="Jörg in jungen Jahren am Computer mit C64" 
          class="w-full h-auto force-visible"
        />
      </div>
      <p class="text-sm text-joerg-500 mt-2 text-left">
        Meine frühen Programmiererfahrungen: Am C64 lernte ich die Grundlagen
      </p>
    </div>
    
    <p>
      Dieses grundlegende Verständnis für Websysteme ist bis heute – wenn auch nicht immer ganz auf dem neuesten Stand – geblieben. 
      Mit meiner Begeisterung für Blockchain-Technologie und Machine Learning bringe ich eine natürliche Affinität 
      für innovative Technologien mit.
    </p>
    
    <h3>Die Entdeckung von Lovable</h3>
    
    <p>
      Für meinen neuen Webauftritt hatte ich bereits mit ChatGPT ein Konzept entwickelt, das auf WordPress und 
      GeneratePress ausgerichtet war. Als ich jedoch durch das Handelsblatt KI-Briefing auf 
      <a href="https://lovable.dev" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">Lovable.dev</a> 
      aufmerksam wurde, war meine Neugier geweckt.
    </p>
    
    <p>
      Was dann geschah, übertraf meine Erwartungen: Ich gab das durch ChatGPT erstellte Handlungsskript bei Lovable.dev ein – 
      und bereits das erste Ergebnis hat mich so "getroffen", dass ich sofort wusste: WordPress kann warten, 
      ich entwickle meine Webseite mit Lovable weiter. Hier erlebte ich Zukunft.
    </p>
    
    <div class="my-6 p-4 bg-amber-50 border-l-4 border-amber-400 rounded-r-lg">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg class="h-5 w-5 text-amber-400" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
          </svg>
        </div>
        <div class="ml-3">
          <p class="text-sm text-amber-700">
            <strong>Transparenz-Hinweis:</strong> Dieser Artikel enthält Partnerlinks zu Lovable.dev. 
            Detaillierte Informationen zur Partnerschaft finden Sie am Ende des Artikels.
          </p>
        </div>
      </div>
    </div>
  `
};
